import { render } from "./ContactAdd.vue?vue&type=template&id=1c338c05&ts=true"
import script from "./ContactAdd.vue?vue&type=script&lang=ts"
export * from "./ContactAdd.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__